/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioCmp } from './pages'

type TIdToPageMap = Record<PageIdStylioCmp, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_CMP: TIdToPageMap = {
  [PageIdStylioCmp.AGE_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/AgeQuestion'),
  },
  [PageIdStylioCmp.HAIR_COLOR_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/questions/HairColorQuestion').then(
        (m) => ({
          default: m.HairColorQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioCmp.WARDROBE_COLORS_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/WardrobeColorsQuestion'
      ).then((m) => ({
        default: m.WardrobeColorsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/WardrobeColorsQuestion'),
  },
  [PageIdStylioCmp.COLOR_CONFIDENCE_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/ColorConfidenceQuestion'
      ).then((m) => ({
        default: m.ColorConfidenceQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/ColorConfidenceQuestion'
      ),
  },
  [PageIdStylioCmp.EYES_COLOR_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/questions/EyesColorQuestion').then(
        (m) => ({
          default: m.EyesColorQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioCmp.BODY_SHAPE_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/questions/BodyShapeQuestion').then(
        (m) => ({
          default: m.BodyShapeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioCmp.BODY_SHAPE_CONFIDENCE_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/BodyShapeConfidenceQuestion'
      ).then((m) => ({
        default: m.BodyShapeConfidenceQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/BodyShapeConfidenceQuestion'
      ),
  },
  [PageIdStylioCmp.SHOW_OFF_FEATURES_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/ShowOffFeaturesQuestion'
      ).then((m) => ({
        default: m.ShowOffFeaturesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/ShowOffFeaturesQuestion'
      ),
  },
  [PageIdStylioCmp.STYLIO_TO_HELP_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/StylioToHelp'),
  },
  [PageIdStylioCmp.MAIN_GOAL_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/questions/MainGoalQuestion').then(
        (m) => ({
          default: m.MainGoalQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/MainGoalQuestion'),
  },
  [PageIdStylioCmp.WHERE_TO_SHOP_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/WhereToShopQuestion'
      ).then((m) => ({
        default: m.WhereToShopQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/WhereToShopQuestion'),
  },
  [PageIdStylioCmp.WARDROBE_PERCENTAGE_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/WardrobePercentageQuestion'
      ).then((m) => ({
        default: m.WardrobePercentageQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/WardrobePercentageQuestion'
      ),
  },
  [PageIdStylioCmp.URGE_1_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant1').then(
        (m) => ({
          default: m.UrgePageVariant1,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant1'),
  },
  [PageIdStylioCmp.URGE_2_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioCmp.URGE_3_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioCmp.URGE_4_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioCmp.URGE_5_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant5'),
  },
  [PageIdStylioCmp.URGE_6_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant6').then(
        (m) => ({
          default: m.UrgePageVariant6,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant6'),
  },
  [PageIdStylioCmp.FACE_SCAN_INTRO_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/abtest/FaceScan/FaceScanIntro').then(
        (m) => ({
          default: m.FaceScanIntro,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/abtest/FaceScan/FaceScanIntro'),
  },
  [PageIdStylioCmp.FACE_SCAN_ANALYSIS_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/abtest/FaceScan/FaceScanAnalysis').then(
        (m) => ({
          default: m.FaceScanAnalysis,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/abtest/FaceScan/FaceScanAnalysis'),
  },
  [PageIdStylioCmp.STYLE_PROFILE_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/urge/StyleProfilePage').then(
        (m) => ({
          default: m.StyleProfilePage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/urge/StyleProfilePage'),
  },
  [PageIdStylioCmp.WARDROBE_READY_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/WardrobeReadyQuestion'
      ).then((m) => ({
        default: m.WardrobeReadyQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/WardrobeReadyQuestion'),
  },
  [PageIdStylioCmp.URGE_7_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant7').then(
        (m) => ({
          default: m.UrgePageVariant7,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant7'),
  },
  [PageIdStylioCmp.URGE_8_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant8').then(
        (m) => ({
          default: m.UrgePageVariant8,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/urge/UrgePageVariant8'),
  },
  [PageIdStylioCmp.STYLE_DRAWN_TO_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/StyleDrawnToQuestion'
      ).then((m) => ({
        default: m.StyleDrawnToQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/StyleDrawnToQuestion'),
  },
  [PageIdStylioCmp.OUTFIT_EMOTION_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/OutfitEmotionQuestion'
      ).then((m) => ({
        default: m.OutfitEmotionQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/OutfitEmotionQuestion'),
  },
  [PageIdStylioCmp.STYLE_DISCOVERY_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/StyleDiscoveryQuestion'
      ).then((m) => ({
        default: m.StyleDiscoveryQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/StyleDiscoveryQuestion'),
  },
  [PageIdStylioCmp.NOTHING_TO_WEAR_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/NothingToWearQuestion'),
  },
  [PageIdStylioCmp.WARDROBE_FEEL_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/WardrobeFeelQuestion'
      ).then((m) => ({
        default: m.WardrobeFeelQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/WardrobeFeelQuestion'),
  },
  [PageIdStylioCmp.SHOPPING_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/questions/ShoppingQuestion').then(
        (m) => ({
          default: m.ShoppingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioCmp.SHOPPING_BUDGET_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/ShoppingBudgetQuestion'
      ).then((m) => ({
        default: m.ShoppingBudgetQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/ShoppingBudgetQuestion'),
  },
  [PageIdStylioCmp.SHOPPING_PRIORITY_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/ShoppingPriorityQuestion'
      ).then((m) => ({
        default: m.ShoppingPriorityQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/ShoppingPriorityQuestion'
      ),
  },
  [PageIdStylioCmp.CURATED_LINKS_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/CuratedLinksQuestion'
      ).then((m) => ({
        default: m.CuratedLinksQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/CuratedLinksQuestion'),
  },
  [PageIdStylioCmp.LIFESTYLE_FOCUS_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/LifestyleFocusQuestion'
      ).then((m) => ({
        default: m.LifestyleFocusQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/LifestyleFocusQuestion'),
  },
  [PageIdStylioCmp.OUTFIT_NEEDS_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/OutfitNeedsQuestion'
      ).then((m) => ({
        default: m.OutfitNeedsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/OutfitNeedsQuestion'),
  },
  [PageIdStylioCmp.WARDROBE_ALIGNS_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/WardrobeAlignsQuestion'
      ).then((m) => ({
        default: m.WardrobeAlignsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/questions/WardrobeAlignsQuestion'),
  },
  [PageIdStylioCmp.LIFESTYLE_CHANGES_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/LifestyleChangesQuestion'
      ).then((m) => ({
        default: m.LifestyleChangesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/LifestyleChangesQuestion'
      ),
  },
  [PageIdStylioCmp.AMAZON_FRUSTRATION_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/AmazonFrustrationQuestion'
      ).then((m) => ({
        default: m.AmazonFrustrationQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp/pages/questions/AmazonFrustrationQuestion'
      ),
  },
  [PageIdStylioCmp.PREPARE_FLOW_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioCmp.EMAIL_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_cmp/pages/email/Email'),
  },
  [PageIdStylioCmp.NAME_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/name/Name').then((m) => ({
        default: m.Name,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_cmp/pages/name/Name'),
  },
  [PageIdStylioCmp.READINESS_LEVEL_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/readinessLevel/ReadinessLevel'
      ).then((m) => ({
        default: m.ReadinessLevel,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/readinessLevel/ReadinessLevel'),
  },
  [PageIdStylioCmp.PRE_PAYWALL_OFFER_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/prePaywallOffer/PrePaywallOffer'
      ).then((m) => ({
        default: m.PrePaywallOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/prePaywallOffer/PrePaywallOffer'),
  },
  [PageIdStylioCmp.SUBSCRIPTIONS_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylioCmp.CANCEL_OFFER_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/cancel-offer/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioCmp.AI_STYLIST_UPSELL_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/ai-stylist-upsell/AiStylistUpsell'
      ).then((m) => ({
        default: m.AiStylistUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_cmp/pages/ai-stylist-upsell/AiStylistUpsell'
      ),
  },
  [PageIdStylioCmp.SUB_UPSELL_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCmp.UPSELL_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/abtest/BundleUpsell/ProportionsUpsell'
      ).then((m) => ({
        default: m.ProportionsUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/abtest/BundleUpsell/ProportionsUpsell'),
  },
  [PageIdStylioCmp.FACE_UPSELL_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/abtest/BundleUpsell/FaceUpsell').then(
        (m) => ({
          default: m.FaceUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/abtest/BundleUpsell/FaceUpsell'),
  },
  [PageIdStylioCmp.BUNDLE_UPSELL_CMP]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_cmp/abtest/BundleUpsell/BundleUpsell').then(
        (m) => ({
          default: m.BundleUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/abtest/BundleUpsell/BundleUpsell'),
  },
  [PageIdStylioCmp.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioCmp.DOWNLOAD_CMP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_cmp/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_cmp/pages/download-app/DownloadDefault'),
  },
}
